import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TransportHistoryService } from '../../_services/transport-history.service';

declare var jQuery: any;

@Component({
  selector: 'app-transport-history',
  templateUrl: './transport-history.component.html',
  styleUrls: ['./transport-history.component.css']
})
export class TransportHistoryComponent implements OnInit {
  private demand: any;
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private service: TransportHistoryService) { }

  ngOnInit() {
  }

  openModal(demand) {

    this.demand = demand;
    //console.log(this.demand);
    jQuery('#to-planning-modal').modal({ inverted: true }).modal('show');
  }

  toPlanning(transportData = null) {

    if (transportData) {
      console.log(`Received Event with this content`)
      //console.log(transportData)

      //console.log('Adding to planning')
      let new_planning = Object.assign({}, this.demand);
      if (transportData.transport) Object.assign(new_planning, { transporter_id: transportData.transport.transporter.id });
      if (transportData.copy_price) {
        Object.assign(new_planning, {
          buy_price: transportData.transport.buy_price,
          single_buy_price: transportData.transport.single_buy_price,
          sell_price: transportData.transport.sell_price,
          single_sell_price: transportData.transport.single_sell_price,
        })
      }
      this.service.toPlanning({ demand_id: this.demand.id, planning: new_planning }).subscribe(res => {
        //console.log(res);
        this.refresh.emit(true);
        jQuery('#to-planning-modal').modal({ inverted: true }).modal('hide');
      })
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/transport-history/transport-history.component.ts